import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { breadcrumbList } from "@/lib/schema";
import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { PrivacyContent } from "@/components/PrivacyContent";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/ar/privacy")({
  head: () => ({
    meta: [
      { title: "سياسة الخصوصية — عراق سيرت" },
      {
        name: "description",
        content:
          "سياسة الخصوصية لشركة عراق سيرت. تعرّف على كيفية جمعنا وحمايتنا واستخدامنا لبياناتك المؤسسية والشخصية بما يتوافق مع معايير الآيزو والقانون الاتحادي العراقي.",
      },
      { property: "og:title", content: "سياسة الخصوصية — عراق سيرت" },
      {
        property: "og:description",
        content: "سياسة الخصوصية لعراق سيرت: كيفية جمع بياناتك المؤسسية والشخصية وحمايتها واستخدامها.",
      },
      { property: "og:url", content: absolute("/ar/privacy") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/ar/privacy") }, ...hreflangLinks("/privacy")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbList([
            { name: "الرئيسية", path: "/ar" },
            { name: "سياسة الخصوصية", path: "/ar/privacy" },
          ]),
        ),
      },
    ],
  }),
  component: PrivacyPageAr,
});

function PrivacyPageAr() {
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <PrivacyContent />
      </main>
      <Footer />
    </div>
  );
}
